import { render, staticRenderFns } from "./AmountDetailDeposit.vue?vue&type=template&id=62aef758&scoped=true"
import script from "./AmountDetailDeposit.vue?vue&type=script&lang=ts"
export * from "./AmountDetailDeposit.vue?vue&type=script&lang=ts"
import style0 from "./AmountDetailDeposit.vue?vue&type=style&index=0&id=62aef758&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62aef758",
  null
  
)

export default component.exports